import { TopBar } from '../../top-bar/TopBar';
import { PublicOptions } from '../../../data/publicOptions';
import { Footer } from '../../footer/Footer';
import './Schedule.css';
import {Link} from "react-router-dom";

export const Schedule = () => {
    return (
        <>
            <TopBar options={PublicOptions} />
            <div className="content">
                <section className="snn-page-section">
                    <h2 className="snn-title">Program</h2>
                    {/*<div className="schedule-links-wrapper">*/}
                    {/*  <p>*/}
                    {/*    <a*/}
                    {/*      className="email-link"*/}
                    {/*      href="https://nnsymposium.s3.us-west-1.amazonaws.com/schedule/O4F_SNN-2024-Program.pdf"*/}
                    {/*    >*/}
                    {/*      <span className="material-symbols-outlined">download</span> Download program*/}
                    {/*    </a>*/}
                    {/*  </p>*/}
                    {/*  <p>*/}
                    {/*    <a*/}
                    {/*      className="email-link"*/}
                    {/*      href="https://nnsymposium.s3.us-west-1.amazonaws.com/schedule/SNN+2024_POSTER+SESSION_1_EVEN.pdf"*/}
                    {/*    >*/}
                    {/*      <span className="material-symbols-outlined">download</span> Download program -*/}
                    {/*      Session poster 1*/}
                    {/*    </a>*/}
                    {/*  </p>*/}
                    {/*  <p>*/}
                    {/*    <a*/}
                    {/*      className="email-link"*/}
                    {/*      href="https://nnsymposium.s3.us-west-1.amazonaws.com/schedule/SNN2024_POSTER+SESSION_2_ODD.pdf"*/}
                    {/*    >*/}
                    {/*      <span className="material-symbols-outlined">download</span> Download program -*/}
                    {/*      Session poster 2*/}
                    {/*    </a>*/}
                    {/*  </p>*/}
                    {/*</div>*/}
                    <div className="schedule-grid">
                        <div className="schedule-grid-day">
                            <h2 className="schedule-grid-day-date">Wednesday, Nov. 19 th</h2>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">9:00 AM - 10:20</p>
                                <p>
                                    Workshop - Part 1 <br/>
                                    The Electrified Interface – Electrochemical Methods of Characterization
                                    <br/>
                                    <small>Scott Donne</small>
                                </p>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">10:20 PM - 10:40 PM</p>
                                <p>
                                    Coffe break ☕️
                                </p>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">10:40 AM - 12:00</p>
                                <p>
                                    Workshop - Part 2 <br/>
                                    The Electrified Interface – Electrochemical Methods of Characterization
                                    <br/>
                                    <small>Scott Donne</small>
                                </p>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">12:20 PM - 1:00 PM</p>
                                <p>
                                    Inauguration
                                </p>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__The+Nature+of+the+Electrified+Interface+in+Electrochemical+Capacitors++--+Factors+Affecting+Interfacial+Capacitance"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">1:00 PM - 1:40 PM</p>
                                <p>
                                    <small className="schedule-grid-event-location">Plenary 1 ✨</small>
                                    <br/>
                                    The Nature of the Electrified Interface in Electrochemical Capacitors  -- Factors Affecting Interfacial Capacitance
                                    <br/>
                                    <small>Scott Donne</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">1:40 PM - 4:00 PM</p>
                                <p>
                                    Lunch 🍽️
                                </p>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/posters"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">4:00 PM - 6:00 PM</p>
                                <p>
                                    Poster session 1
                                    <br/>
                                <small className="schedule-grid-event-location">Batteries, Modelling</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">6:00 PM - 9:00 PM</p>
                                <p>
                                    Welcome reception<br/>
                                </p>
                            </div>
                        </div>
                        <div className="schedule-grid-day">
                            <h2 className="schedule-grid-day-date">Thursday, Nov. 20th</h2>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Sodium+Battery+-+the+Next+TWh+Energy+Storage+Solution"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">9:00 AM - 9:40 AM</p>
                                <p>
                                    <small className="schedule-grid-event-location">Plenary 2 ✨</small>
                                    <br/>
                                    Energy Dense Sodium All-Solid-State Batteries from Materials Design to Interface Engineering
                                    <br/>
                                    <small>James Burrow</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Tuning+the+Electrochemical+Properties+of+hrough+Transition+Metal+Doping+for+Advanced+Energy+Storage"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">9:40 AM - 10:00 AM</p>
                                <p>
                                    Tuning the Electrochemical Properties of Mn₅(H₂O)₄(PO₃OH)₂(PO₄)₂ through Transition Metal Doping for Advanced Energy Storage.
                                    <br/>
                                    <small className="schedule-grid-event-location">Johanna García Montemayor, Roxana Berlanga Pérez, Jorge Alexis Zúñiga Martínez, Oliver Crosnier, Thierry Brousse, Raul Lucio Porto.</small>
                                <br/>
                                <small>UANL-Facultad de Ingeniería Mecánica y Eléctrica.Université de Nantes, CNRS, Institut des Matériaux Jean Rouxel, IMN,Nantes, France</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Enhancing+Flexible+Zinc-+Air+Performance+by+Embrancing+Atomic+Economy+in+Mn+Catalyst+Design+"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">10:00 AM - 10:20 AM</p>
                                <p>
                                    Enhancing Flexible Zinc- Air Performance by Embrancing Atomic Economy in Mn Catalyst
                                    Design.<br/>
                                    <small className="schedule-grid-event-location">César del Ángel Coello Mauleón, Noé
                                        Arjona, Johan S. Barreneche Vasquez, Katherine Andrea Montoya Cano, Minerva
                                        Guerra Balcázar.</small>
                                    <br/>
                                    <small>CIMAV</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Deep+Eutectic+Solvents+and+Direct+Regeneration+as+Scalable+and+Sustainable+Technologies+for+LiFePO4+Battery+Recycling"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">10:20 AM - 10:40 AM</p>
                                <p>
                                    Deep Eutectic Solvents and Direct Regeneration as Scalable and Sustainable
                                    Technologies for LiFePO4 Battery Recycling.<br/>
                                    <small className="schedule-grid-event-location">César Eduardo Sánchez Rodríguez,
                                        Marina Elizabeth Rincón González, Oscar Andrés Jaramillo-Quintero, José Ramón
                                        Herrera-Garza, Julio Cesar Calva-Yañez</small>
                                    <br/>
                                    <small>IER-UNAM / SECIHTI-TecNM/I.T. Tijuana.</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Study+of+the+effect+of+Prussian+blue+analogue-type+active+particles+in+polymeric+electrolyte+membranes"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">10:40 AM - 11:00 AM</p>
                                <p>
                                    Study of the effect of Prussian blue analogue-type active particles Na2Mn[Fe(CN)6]
                                    in polymeric electrolyte membranes.<br/>
                                    <small className="schedule-grid-event-location">Ivan Gerardo Morales-Cruz, Alfredo
                                        Romero-Contreras, Miguel Amado Briseno, Arian Espinoza-Roa, Eduardo Maximiano
                                        |Sanchez-Cervantes.</small>
                                    <br/>
                                    <small>UANL-Facultad de Ciencias Químicas. / CIQA-Apodaca, NL.</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">11:00 AM - 11:30 AM</p>
                                <p>
                                    Coffe break ☕️
                                </p>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Fit-to-purpose+power+sources+ecodesigning+portable+energy+storage+devices"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">11:30 AM - 12:10 PM</p>
                                <p>
                                    <small className="schedule-grid-event-location">Plenary 3 ✨</small>
                                    <br/>
                                    Fit-to-purpose power sources: ecodesigning portable energy devices.
                                    <br/>
                                    <small>Juan Pablo Esquivel</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Chitosan+binders+for+sustainable+lithium-sulfur+batteries+Synergistic+effects+of+mechanical+and+polysulfide+trapping+properties"}>
                                    <hr/>
                                    <p className="schedule-grid-event-hour">12:10 PM - 12:30 PM</p>
                                    <p>
                                        Chitosan binders for sustaianles lithium-sulfur batteries Synergeic effects of
                                        mechanical and polysulfide trapping properties.<br/>
                                        <small className="schedule-grid-event-location">Mayrén A., AlcarazEspinoza J.,
                                            Hernández Sánchez A., González I., Ramos Sánchez G.</small>
                                        <br/>
                                        <small>UAM-Iztapalapa-Dep. Química / Ingeniería. / La. Nal. CONAHCYT-Baterías ion-Li
                                            (BIL-DEMo).</small>
                                    </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__fc47572c-5a79-4275-9de8-8275dbabb77a"}>
                                    <hr/>
                                    <p className="schedule-grid-event-hour">12:30 PM - 12:50 PM</p>
                                    <p>
                                        Theoretical and Experimental Analysis of Li+1 and Na+1 ion intercalation into into
                                        de MNO2 structure for advanced supercapacitors applications.<br/>
                                        <small className="schedule-grid-event-location">Manzo Mendoza J., Celaya A., Cuentas
                                            Gallegos A.</small>
                                        <br/>
                                        <small>CNyN-UNAM</small>
                                    </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__7877233a-18eb-41d8-bfcd-aa657a3d4889"}>
                                    <hr/>
                                    <p className="schedule-grid-event-hour">12:50 PM - 1:00 PM</p>
                                    <p>
                                        Study of Materials for Energy Storage Applications throug DFT Calculations<br/>
                                        <small className="schedule-grid-event-location">Rodrigo Ponce Pérez </small>
                                        <br/>
                                        <small>CNyN-UNAM</small>
                                    </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Modulating+the+Nitrogen+species+of+N-doped+Graphitic+nanostructures+the+key+role+in+the+ORR+for+Energy+Storage+devices"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">1:10 PM - 1:30 PM</p>
                                <p>
                                    Modulating the Nitrogen species of N-doped Graphitic nanostructures: the key role in
                                    the ORR for Energy Storage devices.<br/>
                                    <small className="schedule-grid-event-location">Jose M. Ruiz-Marizcal, Miguel A.
                                        Amezcua-Navarro, Carlos Belman-Rodriguez, Jose I. Paez-Ornelas, Noe
                                        Fernandez-Escamilla, Jonathan Guerrero-Sanchez, Noboru Takeuchi, Rodrigo Ponce,
                                        Jose M. Romo-Herrera.</small>
                                    <br/>
                                    <small>PNC-CICESE-UNAM</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Computational+simulation+of+current+and+potential+distribution+in+an+anode+compartment+of+an+organic+flow+cell"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">1:30 PM - 1:50 PM</p>
                                <p>
                                    Computational simulation of current and potential distribution in an anode
                                    compartment of an organic flow cell. <br/>
                                    <small className="schedule-grid-event-location">Eder Salvador Castillo Romero,
                                        Margarita Miranda Hernández. </small>
                                    <br/>
                                    <small>IER - UNAM</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">1:40 PM - 4:00 PM</p>
                                <p>
                                    Lunch 🍽️
                                </p>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/posters-2"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">4:00 PM - 6:00 PM</p>
                                <p>
                                    Poster session 2
                                    <br/>
                                    <small className="schedule-grid-event-location">Capacitors, Engineering</small>
                                </p>
                                </Link>
                            </div>
                        </div>
                        <div className="schedule-grid-day">
                            <h2 className="schedule-grid-day-date">Friday, Nov. 21 th</h2>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__30f63781-d7f2-413d-9bc5-ab805b90a2e3"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">9:00 AM - 9:40 AM</p>
                                <p>
                                    <small className="schedule-grid-event-location">Plenary 4 ✨</small>
                                    <br/>
                                    Challenges and opportunities in the direct recycling of new generation electrode
                                    materials.
                                    <br/>
                                    <small>Montserrat Galceran</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Pseudocapacitive+Li-ion+batteries+of+Mn3O4+covered+with+FeOx"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">9:40 AM - 10:00 AM</p>
                                <p>
                                    Pseudocapacitive Li-ion batteries of Mn3O4 covered with FeOx.<br/>
                                    <small className="schedule-grid-event-location">Enrique Quiroga-González, María Lizbeth Barrios-Reyna, Adriana Morales-Hernández.	</small>
                                    <br/>
                                    <small>BUAP-Institute of Physics</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Strategies+for+designing+high-performance+energy+storage+materials+with+local+resources+from+Coahuila"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">10:00 AM - 10:20 AM</p>
                                <p>
                                    Strategies for designing high-performance energy storage materials with local resources from Coahuila.	<br/>
                                    <small className="schedule-grid-event-location">Ivonne Alonso-Lemus</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__0905f385-05b7-443b-b99b-7fa03b7bf006"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">10:20 AM - 10:40 AM</p>
                                <p>
                                    Power Electronics an optimum base of Battery Energy Storage System integration<br/>
                                    <small className="schedule-grid-event-location">Nadia M. Salgado-Herrera, R. Jean, N.M. Lucie Auguste, D.A. Canul-Reyes, M. Robles, O. Rodriquez-Hernandez.	</small>
                                    <br/>
                                    <small>IER - UNAM</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Electric+Vehicle+Adoption+A+Technical+and+Economic+Analysis+of+Mexico+and+Denmark"}>
                                <hr/>
                                <p className="schedule-grid-event-hour">10:40 AM - 11:00 AM</p>
                                <p>
                                    Electric Vehicle Adoption: A Technical and Economic Analysis of Mexico and Denmark.<br/>
                                    <small className="schedule-grid-event-location">Jaime Isaias Navarro Rivera, Monica Camas-Nafate, Nicolas Haro Falcon.</small>
                                    <br/>
                                    <small>UAG-Centro Universitario de Tonalá-Depto. Estudios del Agua y la Energía-Ingeniería en Energía.</small>
                                </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">11:00 AM - 11:30 AM</p>
                                <p>
                                    Coffe break ☕️
                                </p>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__Economic+analysis+of+a+PV+system+with+hydrogen+and+supercapacitors+hybrid+energy+storage"}>
                                    <hr/>
                                    <p className="schedule-grid-event-hour">11:30 AM - 11:50 AM</p>
                                    <p>
                                        Economic analysis of a PV system with hydrogen and supercapacitors hybrid energy storage.<br/>
                                        <small className="schedule-grid-event-location">María G. Reveles Miranda, Romeli Barbosa, Daniella E. Pacheco Catalán	</small>
                                        <br/>
                                        <small>Centro de Investigación Científica de Yucatán (CICY)-PCTY	</small>
                                    </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event abstract-link">
                                <Link to={"/abstracts/view/abstract__61e8ef71-0815-4b17-85e1-fef90777a150"}>
                                    <hr/>
                                    <p className="schedule-grid-event-hour">11:50 AM - 12:10 PM</p>
                                    <p>
                                        Towards an Energy Storage Science: Insights from Ensenada, Baja California, México	<br/>
                                        <small className="schedule-grid-event-location">Jassiel Rodríguez Barreras, Hugo Tiznado, Jonathan Guerrero, Ana Karina Cuentas-Gallegos	</small>
                                        <br/>
                                        <small>CICESE, CNYN-UNAM	</small>
                                    </p>
                                </Link>
                            </div>
                            <div className="schedule-grid-event">
                                <hr/>
                                <p className="schedule-grid-event-hour">12:10 PM - 1:30 PM</p>
                                <p>
                                    Round Table and Closing Ceremony
                                </p>
                            </div>
                        </div>
                    </div>
                </section>
            </div>
            <Footer/>
        </>
    );
};
